export default __webpack_public_path__ + "media/images/images/portrait/small/avatar-s-23-206fbd20188ef5a6bcb09629d40e3bf7.png";